import { createSlice } from '@reduxjs/toolkit';

const undoRedo = createSlice({
  name: 'undoRedo',
  initialState: {
    counter: 1, // we update counter to rerender some components after undo/redo
    colorCounter: 1,
  },
  reducers: {
    updateUndoRedoCounter: (state) => {
      state.counter = state.counter + 1;
    },
    updateUndoRedoColorCounter: (state) => {
      state.colorCounter = state.colorCounter + 1;
    }
  },
});

export const { updateUndoRedoCounter, updateUndoRedoColorCounter } = undoRedo.actions;
export const undoRedoReducer = undoRedo.reducer;

export const selectUndoRedoCounter = state => state.undoRedo.counter;
export const selectUndoRedoColorCounter = state => state.undoRedo.colorCounter;